import BrandLogo from "@/components/common/BrandLogo";
import { padCountdown, useLaunchCountdown } from "@/lib/launchCountdown";
import { resolveLaunchGateMessage } from "@/lib/launchGateCopy";

function CountdownUnit({ value, label }) {
  return (
    <div className="flex flex-col items-center min-w-[72px]">
      <div className="w-full rounded-xl bg-white/10 border border-white/15 px-3 py-4 text-[28px] lg:text-[32px] font-semibold tabular-nums text-white">
        {padCountdown(value)}
      </div>
      <span className="mt-2 text-[11px] font-semibold uppercase tracking-[0.18em] text-white/60">
        {label}
      </span>
    </div>
  );
}

/**
 * Full-screen gate — no links, no navigation. Shown for every non-admin route when enabled.
 */
export default function LaunchGatePage({ message, launchAt }) {
  const countdown = useLaunchCountdown(launchAt);
  const displayMessage = resolveLaunchGateMessage(message);

  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center px-6 py-16 text-white"
      style={{
        background:
          "radial-gradient(ellipse 80% 50% at 50% 0%, rgba(40, 202, 113,0.35) 0%, transparent 55%), linear-gradient(180deg, #0B1426 0%, #1D2D3F 100%)",
      }}
      data-testid="launch-gate-page"
    >
      <div className="w-full max-w-[720px] text-center">
        <div className="flex justify-center mb-10">
          <BrandLogo size="lg" />
        </div>

        <p className="text-[11px] font-semibold uppercase tracking-[0.22em] text-primary mb-4">
          Coming soon
        </p>

        <h1 className="text-[36px] sm:text-[44px] lg:text-[52px] font-semibold tracking-tight leading-[1.08]">
          PaisaCX is launching shortly
        </h1>

        <p className="mt-6 text-[16px] lg:text-[17px] leading-[1.75] text-white/75 max-w-[560px] mx-auto">
          {displayMessage}
        </p>

        {countdown && (
          <div
            className="mt-10 flex flex-wrap justify-center gap-3 lg:gap-4"
            data-testid="launch-countdown"
          >
            <CountdownUnit value={countdown.days} label="Days" />
            <CountdownUnit value={countdown.hours} label="Hours" />
            <CountdownUnit value={countdown.minutes} label="Minutes" />
            <CountdownUnit value={countdown.seconds} label="Seconds" />
          </div>
        )}

        <p className="mt-12 text-[12px] text-white/40">
          The exchange is temporarily unavailable while we prepare for launch.
        </p>
      </div>
    </div>
  );
}
